import React from 'react';
import { useCurrency, Money } from '@app/currency';
import { Flex, Tag, TagLabel } from '@stockx/ui';
import { FooterProps } from '../types';
import useProductCustomerActivity from '../../../../../hooks/useProductCustomerActivity';

const CustomerActivityFooter = ({
  type,
  product,
  displayData,
}: FooterProps) => {
  const {
    customerActivity: [bid = {}, ask = {}],
  } = useProductCustomerActivity(product);

  const { currency } = useCurrency();
  const amount = type === 'your_ask' ? ask?.amount : bid?.amount;

  return (
    <Flex mt="1">
      <Tag>
        <TagLabel mr="1">{displayData?.label}</TagLabel>
        <TagLabel color="green.700">
          {Money.getDollars(amount, true, true, currency)}
        </TagLabel>
      </Tag>
    </Flex>
  );
};

export default CustomerActivityFooter;
